import {
  InputNames,
  plateValue,
} from '@/common/components/base/input/plate/vehiclePlateInput/vehiclePlateInput.type';
import { UseControllerProps } from 'react-hook-form';

export const VehiclePlateRules: Record<
  InputNames,
  UseControllerProps['rules']
> = {
  left: { required: true, min: 11, max: 99 },
  right: { required: true, min: 111, max: 999 },
  letter: { required: true },
  iran: { required: true, min: 10, max: 99 },
};

export const VehiclePlateEmptyRules = (value: plateValue) => {
  if (value.plate.letter?.label === 'الف') {
    return value.plateString.length === 10 || 'پلاک را کامل وارد کنید';
  }
  return value.plateString.length === 8 || 'پلاک را کامل وارد کنید';
};
